import Honeybadger from "@honeybadger-io/js";

// Booking Engine Integrations Config
const honeybadgerConfigOld = {
  apiKey: "5a08bf30",
  environment: process.env.NODE_ENV,
  //reportData: true, // uncommment if you want to test in development
  disabled: process.env.NODE_ENV === "development",
  enableUncaught: false,
};

// BE Error Detection Config
const honeybadgerConfig = {
  apiKey: "hbp_FdTaVmDrykFruE2DzBSvQTs4S0Aovq1Zfzn0", //5a08bf30
  environment: process.env.NODE_ENV, // use 'production', to debug locally
  async: true,
  maxErrors: 20,
  onerror: false, // ignore errors thrown by window (legacy)
  enableUncaught: false, // ignore errors thrown by window (new)
  enableUnhandledRejection: false, // ignore unhandled Promise rejections (reports not our errors when true)
  reportData: true, // uncommment if you want to test in development
  disabled: false,
  debug: process.env.NODE_ENV === "development",
};

export const honeybadger = Honeybadger.configure(honeybadgerConfig);

export const numOfHotels: string = "900";

export const guestbookSites: any = {
  development: {
    rewardsadmin: {
      url: "https://gstbk.com:3002",
    },
    guestbook: {
      url: "https://gstbk.com:3001",
    },
    hotelIntegration: {
      url: "https://gstbk.com:3001",
    },
    rewardsdash: {
      url: "https://gstbk.com:3001",
    },
    amplitude: {
      api_key: "8e6dd01370b3a4d924953b6ca4aab870",
    },
    rudderstack: {
      api_key: "2T5H7vNQQvU7TZdcHqhgdvn5dkO",
      // Dev talks to RudderStack directly -- it never runs inside a
      // CSP-restricted booking engine page.
      data_plane_url: "https://theguestbovybg.dataplane.rudderstack.com",
    },
  },
  staging: {
    rewardsadmin: {
      url: "https://staging.rewardsadmin.com",
    },
    guestbook: {
      url: "https://theguestbookrewards.com",
    },
    hotelIntegration: {
      url: "https://staging-integrations.theguestbook.com",
    },
    rewardsdash: {
      url: "https://staging-integrations.theguestbook.com",
    },
    amplitude: {
      api_key: "8e6dd01370b3a4d924953b6ca4aab870",
    },
    rudderstack: {
      api_key: "2T5H9yHynU0KEcNGwKcUuiTWHfC",
      // Still direct: the staging-assets.theguestbook.com distribution
      // (E22T9WSY6CQGB1) doesn't have the /events behaviour yet. Switch to
      // "https://staging-assets.theguestbook.com/events" once it does.
      data_plane_url: "https://theguestbovybg.dataplane.rudderstack.com",
    },
  },
  production: {
    rewardsadmin: {
      url: "https://rewardsadmin.com",
    },
    guestbook: {
      url: "https://theguestbook.com",
    },
    hotelIntegration: {
      url: "https://integrations.theguestbook.com",
    },
    rewardsdash: {
      url: "https://integrations.theguestbook.com",
    },
    amplitude: {
      api_key: "76cd2176bee3fed1d3073ae17c380653",
    },
    rudderstack: {
      api_key: "2T5HBwIVKeEOKhSlON42BQfQU2O",
      // First-party proxy for event delivery: a /events/* behaviour on the
      // existing assets.theguestbook.com distribution (ECV9AQR7N889H) fronts
      // the RudderStack data plane, with a CloudFront Function stripping the
      // /events prefix. Booking engines that ship a strict CSP -- Synxis
      // being the big one -- allowlist *.theguestbook.com but not
      // rudderstack.com, so events posted straight to the data plane are
      // blocked by the browser before they leave the page.
      data_plane_url: "https://assets.theguestbook.com/events",
      // Same proxy for the control plane: a /rs-config/* behaviour on the same
      // distribution fronts api.rudderstack.com. load() fetches sourceConfig
      // before it will send anything, and those same CSPs block that host --
      // when the fetch fails the SDK never finishes initialising, which is why
      // Synxis produced no events at all rather than fewer. Verified from
      // be.synxis.com: returns 200 and the Frontend Prod source config.
      config_url: "https://assets.theguestbook.com/rs-config",
    },
  },
};

export const environment = process.env.NODE_ENV;

export const googleOAuthKey =
  "504219410999-666ee23l8gd4kcanjeijobkf6hvmr1a0.apps.googleusercontent.com";

export const langHash = {
  "1": "pt",
  "2": "en",
  "3": "fr",
  "4": "de",
  "5": "zh-HK",
  "6": "it",
  "7": "ko",
  "8": "es",
  "9": "no",
  "10": "sv",
  "11": "ja",
  "12": "nl",
  "13": "cs",
  "14": "da",
  "15": "fi",
  "16": "el",
  "17": "hi",
  "18": "Malay",
  "19": "pl",
  "20": "ru",
  "21": "zh-TW",
  "22": "tr",
  "23": "vi",
  "24": "zh-CN",
  "25": "ar",
  "26": "zh",
};
